import React from 'react';
import { useForm } from 'react-hook-form';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { Checkbox } from '../../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { useDeleteTrustMutation } from '../../../../api/useDeleteTrustMutation';
import { Alert } from '../../../../../../CommonComponents/OPL/Alert/Alert';

const FORM_ID = 'personal-info--delete-trust-form';
export const HEADER_ID = 'personal-info--delete-trust-modal-header';

interface FormValues {
  deleteTrustAssociations: boolean;
}

interface Props {
  trustId: string;
  onClose(): void;
}

export const DeleteTrustModal: React.FC<Props> = ({ trustId, onClose }) => {
  const { register, handleSubmit } = useForm<FormValues>({
    defaultValues: {
      deleteTrustAssociations: false,
    },
  });

  const {
    mutateAsync: deleteTrust,
    isLoading: isDeletingTrust,
    error: deleteTrustError,
  } = useDeleteTrustMutation();

  const onSubmit = async ({ deleteTrustAssociations }: FormValues) => {
    try {
      await deleteTrust({
        trustId,
        keepTrustAssociations: !deleteTrustAssociations,
      });

      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: HEADER_ID }}
    >
      <ModalHeader as="h2" id={HEADER_ID} variant="warning">
        Are you sure you want to delete this trust?
      </ModalHeader>

      {deleteTrustError && (
        <Alert message={deleteTrustError.message} variant="error" mb="16" mx="24" />
      )}

      <ModalBody as="form" id={FORM_ID} onSubmit={handleSubmit(onSubmit)}>
        <Checkbox {...register('deleteTrustAssociations')}>
          Delete all associated accounts, assets, or income for this trust.
        </Checkbox>
      </ModalBody>

      <ModalFooter as="footer">
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button type="submit" form={FORM_ID} variant="error" ml="8" isLoading={isDeletingTrust}>
          Delete Trust
        </Button>
      </ModalFooter>
    </Modal>
  );
};
